/**
 * Fallback GeoJSON overlay using Google Maps native Data layer.
 * Provides the same public API as CanvasGeoJsonOverlay so the store
 * can use either implementation transparently.
 */
export class NativeGeoJsonOverlay {
  constructor(map, geojson, style = {}) {
    this.map = map;
    this.geojson = geojson;
    this.bounds = null;
    this.dataLayer = new google.maps.Data({ map });
    this.style = {
      fillColor: style.fillColor ?? '#3388ff',
      markerFillColor: style.markerFillColor ?? style.fillColor ?? '#3388ff',
      strokeColor: style.strokeColor ?? '#3388ff',
      strokeWeight: style.strokeWeight ?? 2,
      fillOpacity: style.fillOpacity ?? 0.2,
      strokeOpacity: style.strokeOpacity ?? 1,
      icon: style.icon ?? null,
      visible: style.visible !== false,
      zIndex: style.zIndex ?? 1
    };

    this._applyStyle();
    this._loadGeoJson(geojson);
  }

  _applyStyle() {
    const s = this.style;
    this.dataLayer.setStyle({
      fillColor: s.fillColor,
      fillOpacity: s.fillOpacity,
      strokeColor: s.strokeColor,
      strokeWeight: s.strokeWeight,
      strokeOpacity: s.strokeOpacity,
      icon: s.icon,
      visible: s.visible,
      zIndex: s.zIndex
    });
  }

  _loadGeoJson(geojson) {
    if (!geojson) return;

    const features = this.dataLayer.addGeoJson(geojson);
    this._calculateBounds(features);
  }

  _calculateBounds(features) {
    this.bounds = new google.maps.LatLngBounds();
    features.forEach(feature => {
      feature.getGeometry().forEachLatLng(latLng => {
        this.bounds.extend(latLng);
      });
    });
  }

  getBounds() {
    return this.bounds;
  }

  setStyle(style) {
    this.style = { ...this.style, ...style };
    this._applyStyle();
  }

  setVisible(visible) {
    this.style.visible = visible;
    this._applyStyle();
  }

  setMap(map) {
    this.map = map;
    this.dataLayer.setMap(map);
  }
}
